export default 'https://tme.understood.org/assets/Light_Texture03.fbd2e811.jpg'